/* oxlint-disable react/jsx-props-no-spreading -- props are intentionally forwarded by this adapter */
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useField } from 'remix-validated-form'
import FormInputWrapper, { BaseInputClasses, FormInputWrapperProps } from './FormInputWrapper'

export type FormTextAreaInputProps = {
  rows?: number
  readOnly?: boolean
  readOnlyAsLabel?: boolean
  labelClassName?: string
  errorClassName?: string
} & FormInputWrapperProps<HTMLTextAreaElement>

export default function FormTextArea({
  name,
  label,
  placeholder,
  readOnly,
  cols,
  rows = 6,
  readOnlyAsLabel,
  className,
  wrapperClassName,
  labelClassName,
  errorClassName,
  showErrorIcon,
  newLineError,
  onChange,
  ...props
}: FormTextAreaInputProps) {
  const { error, getInputProps, validate } = useField(name)
  const [textLength, setTextLength] = useState<number>(props.defaultValue?.toString().length || 0)

  useEffect(() => {
    setTextLength(props.defaultValue?.toString().length || 0)
  }, [props.defaultValue])

  const inputClasses = classNames(
    className,
    BaseInputClasses,
    readOnly &&
      (readOnlyAsLabel
        ? `border-default shadow-elevation-1 read-only:cursor-not-allowed read-only:border-none read-only:p-0 read-only:shadow-none read-only:text-subtle read-only:focus:text-subtle`
        : `border-default shadow-elevation-1 read-only:cursor-not-allowed read-only:border-default read-only:bg-surface-muted read-only:text-subtle read-only:focus:text-subtle`),
  )

  return (
    <>
      <FormInputWrapper
        {...{
          name,
          label,
          error,
          showErrorIcon,
          cols,
          newLineError,
          wrapperClassName,
          className: labelClassName ?? `text-body-sm`,
          errorClassName,
          defaultValue: props.defaultValue,
        }}
      >
        <div className="relative">
          <textarea
            rows={rows}
            defaultValue={props.defaultValue}
            {...getInputProps({ ...props, placeholder, readOnly: readOnly })}
            className={classNames(inputClasses, `py-4 placeholder-neutral-400`)}
            onChange={(e) => {
              setTextLength(e.target.value.length)
              onChange?.(e)
            }}
            onInput={() => {
              // this triggers a validation on input, it allows to update error status on the fly
              validate()
            }}
          />
          {props.maxLength && <span className="text-body-sm text-minimal ">{`${textLength}/${props.maxLength}`}</span>}
        </div>
      </FormInputWrapper>
    </>
  )
}
